export default __webpack_public_path__ + "static/media/money.62034c9a.svg";